import { lazy } from 'react';
import { Loader } from '@client/components/common/Loader';
import { Modal } from '@client/components/globals/Modal';

const CreateProfileLoader = lazy(() => import('./CreateProfile'));

export const openCreateProfileModal = () => Modal.show({
  dialogTitleCondensed: true,
  title: ' ',
  body: <Loader load={CreateProfileLoader} />,
  buttons: [],
});
